import namedEvents from './named-events';
import { User } from 'src/types/user';

export interface EventDataSource {
  user?: User;
  eventName: string;
  dataSource?: any;
  dateTime: Date;
}

interface Props {
  eventName: string;
  dataSource?: any;
  user?: User | null;
}

//TODO: Using any for now until we have a clear definition of what the shape of the dataSources object will look like (Dont get mad Mick)
// LMAO - Mick
export function trackNamedEvent({ eventName, user, dataSource }: Props) {
  const eventObject = {
    eventName,
    dataSource,
    user,
    dateTime: new Date(),
  };
  if (namedEvents.isConnected) {
    namedEvents.connection.send('SendJsonMessage', JSON.stringify(eventObject));
  }
}
